import { useEffect, useState } from "react";

const PARTICLE_COUNT = 12;
const COLORS = [
  "hsl(var(--primary))",
  "hsl(var(--accent))",
  "#F59E0B",
  "#10B981",
  "#8B5CF6",
  "#EC4899",
];

interface Particle {
  id: number;
  x: number;
  y: number;
  color: string;
  size: number;
  angle: number;
  speed: number;
}

const StepCompletionEffect = ({ active }: { active: boolean }) => {
  const [particles, setParticles] = useState<Particle[]>([]);
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    if (!active) {
      setParticles([]);
      setShowCheck(false);
      return;
    }

    const generated: Particle[] = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
      id: i,
      x: 50 + (Math.random() - 0.5) * 20,
      y: 50 + (Math.random() - 0.5) * 20,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: 3 + Math.random() * 4,
      angle: (360 / PARTICLE_COUNT) * i + Math.random() * 30,
      speed: 30 + Math.random() * 30,
    }));

    setParticles(generated);
    setShowCheck(true);

    const timer = setTimeout(() => setParticles([]), 800);
    return () => clearTimeout(timer);
  }, [active]);

  if (!active) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-10">
      {/* Confetti particles */}
      {particles.map((p) => {
        const rad = (p.angle * Math.PI) / 180;
        const tx = Math.cos(rad) * p.speed;
        const ty = Math.sin(rad) * p.speed;
        return (
          <span
            key={p.id}
            className="absolute rounded-full"
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: p.size,
              height: p.size,
              backgroundColor: p.color,
              animation: "confetti-burst 0.7s ease-out forwards",
              // @ts-ignore
              "--tx": `${tx}px`,
              "--ty": `${ty}px`,
            } as React.CSSProperties}
          />
        );
      })}

      {/* Checkmark ring pulse */}
      {showCheck && (
        <div
          className="absolute inset-0 flex items-start justify-start pl-4 pt-4"
          style={{ animation: "check-ring 0.6s ease-out forwards" }}
        >
          <div
            className="w-10 h-10 rounded-full border-2 border-primary opacity-0"
            style={{ animation: "ring-expand 0.6s ease-out 0.1s forwards" }}
          />
        </div>
      )}
    </div>
  );
};

export default StepCompletionEffect;
